import EmblaCarousel, {EmblaCarouselType} from 'embla-carousel';
import * as React from 'react';
import {Pages} from '../../pages';
import {Container} from '../grid/container';
import './style.scss';
import {Translation} from "../../lang";

const leftArrow = '/assets/src/components/layouts/left-arrow.svg';
const rightArrow = '/assets/src/components/layouts/right-arrow.svg';

export class TeamComponent extends React.Component<any, any> {
    public embla: EmblaCarouselType | null = null;
    public carouselRef: any;

    public state: any = {
        page: 0,
        fading: false
    };

    public componentDidMount(): void {
        if (!this.carouselRef) {
            return;
        }

        // A középre igazított, loopoló szalagot az Embla adja; a kiválasztott elem
        // indexe közvetlenül a selectedScrollSnap(), nincs szükség klónszámolásra.
        this.embla = EmblaCarousel(this.carouselRef, {
            loop: true,
            align: 'center',
            containScroll: false,
            skipSnaps: false
        });

        // Mozgás közben halványodjon ki a skill-lista, megérkezéskor vissza.
        this.embla.on('select', () => this.setState({fading: true}));
        this.embla.on('settle', () => this.setState({
            page: this.embla ? this.embla.selectedScrollSnap() : 0,
            fading: false
        }));
    }

    public componentWillUnmount(): void {
        if (this.embla) {
            this.embla.destroy();
            this.embla = null;
        }
    }

    public goTo(index: number) {
        if (this.embla) {
            this.embla.scrollTo(index);
        }
    }

    render() {
        return <Container className="teamComponent">

            <div className="container">

                <div className="col-12">
                    <h1 className="MS text-white text-center fw-bold fst-italic">{Translation.get('team.title')}</h1>
                    <div className="col-12 col-sm-10 offset-sm-1 col-lg-8 offset-lg-2">
                        <p className="MS text-white text-center fst-italic">{Translation.get('team.description')}</p>
                    </div>

                    <div className="col-12">
                        <div className="slickWrapper content-height relative">

                            <div className="centerBg">
                                <img src={leftArrow} alt="" className="prev"/>
                                <img src={rightArrow} alt="" className="next"/>
                            </div>
                            <div className="skill-carousel" ref={(ref: any) => { this.carouselRef = ref; }}>
                                <div className="skill-track">
                                    {Pages.team.content.map((item: any, key: number) => <div
                                        key={key}
                                        onClick={() => this.goTo(key)}
                                        className="item content-height text-center">
                                        <span
                                            className="MS text-white text-center content-height">{item.title}</span>
                                    </div>)}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className={`w-100 skillWrapper d-block animated ${this.state.fading ? 'fadeOut' : 'fadeIn'}`}>
                        <div className="row">
                            {((Pages.team.content[this.state.page] || {}).skills || []).map((skill: string, key: number) =>
                                <div
                                    className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-3 text-white text-center skill"
                                    key={key}>{skill}</div>)}
                        </div>
                    </div>
                </div>

            </div>

        </Container>;
    }
}
